import { Button, Card, Col, Form, Input, Row, Table, Typography } from "antd";

import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import {
  useAddLeavePolicyMutation,
  useGetLeavePoliciesQuery,
} from "../../redux/rtk/features/leavePolicy/leavePolicyApi";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import TablePagination from "./../CommonUi/TablePagination";

function CustomTable({ list, loading }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "name",
      key: "name",
    },

    {
      id: 3,
      title: "Total Paid Leave",
      dataIndex: "paidLeaveCount",
      key: "paidLeaveCount",
    },

    {
      id: 3,
      title: "Total Unpaid Leave",
      dataIndex: "unpaidLeaveCount",
      key: "unpaidLeaveCount",
    },
    {
      id: 4,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id) => (
        <UserPrivateComponent permission={"readSingle-leavePolicy"}>
          <ViewBtn path={`/admin/leave-policy/${id}/`} />
        </UserPrivateComponent>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  return (
    <Card>
      <div className='text-center my-2 flex justify-between'>
        <h5 className='department-list-title text-color-2 text-xl mb-2'>
          Leave Policy List
        </h5>
        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className='btn btn-dark btn-sm mb-1'
                filename='leave-policy'
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      <Table
        scroll={{ x: true }}
        loading={!list || loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
      />
    </Card>
  );
}

const AddLeavePolicy = ({ drawer }) => {
  const { data: list, isLoading } = useGetLeavePoliciesQuery();
  const [addSingleLeavePolicy, { isLoading: addLoading }] =
    useAddLeavePolicyMutation();
  const [form] = Form.useForm();

  const { Title } = Typography;

  const onFinish = async (values) => {
    const FormData = {
      ...values,
      paidLeaveCount: parseInt(values.paidLeaveCount),
      unpaidLeaveCount: parseInt(values.unpaidLeaveCount),
    };

    const resp = await addSingleLeavePolicy(FormData);

    if (resp) {
      form.resetFields();
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding department");
  };
  const columns = [
    {
      id: 1,
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "name",
      key: "name",
    },

    {
      id: 3,
      title: "Total Paid Leave",
      dataIndex: "paidLeaveCount",
      key: "paidLeaveCount",
    },

    {
      id: 3,
      title: "Total Unpaid Leave",
      dataIndex: "unpaidLeaveCount",
      key: "unpaidLeaveCount",
    },
    {
      id: 4,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id) => (
        <UserPrivateComponent permission={"readSingle-leavePolicy"}>
          <ViewBtn path={`/admin/leave-policy/${id}/`} />
        </UserPrivateComponent>
      ),
    },
  ];
  return (
    <Fragment bordered={false}>
      <UserPrivateComponent permission={"create-leavePolicy"}>
        <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={drawer ? 22 : 12}
            xl={drawer ? 22 : 12}
            className='column-design border rounded card-custom'
          >
            <Title level={4} className='m-2 mt-5 mb-5 text-center'>
              Add Leave Policy
            </Title>
            <Form
              style={{ marginBottom: "40px" }}
              form={form}
              eventKey='department-form'
              name='basic'
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 12,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              <div>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label='Name'
                  name='name'
                  rules={[
                    {
                      required: true,
                      message: "Please input your leave-policy name!",
                    },
                  ]}
                >
                  <Input placeholder='Policy 10-12' />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label='Paid Leave '
                  name='paidLeaveCount'
                  rules={[
                    {
                      required: true,
                      message: "Please input your paid leave!",
                    },
                  ]}
                >
                  <Input placeholder='20' />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label='Unpaid Leave '
                  name='unpaidLeaveCount'
                  rules={[
                    {
                      required: true,
                      message: "Please input your unpaid Leave !",
                    },
                  ]}
                >
                  <Input placeholder='10' />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 6,
                    span: 12,
                  }}
                >
                  <Button
                    type='primary'
                    size='large'
                    htmlType='submit'
                    block
                    loading={addLoading}
                  >
                    Add New Policy
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
      <hr />
      <h5 className='department-list-title text-color-2 text-xl mb-2'>
        Leave Policy List
      </h5>

      {drawer || (
        <TablePagination
          columns={columns}
          csvFileName={"Leave Policies"}
          list={list}
          loading={isLoading}
          permission={"readAll-leavePolicy"}
        />
      )}
    </Fragment>
  );
};

export default AddLeavePolicy;
